<template>
  <div class="training">
    <h1>Training</h1>
    <ul>
      <li>Human Right Training</li>
      <li>Child Protection (Human Trafficking and Abused)</li>
      <li>
        Education in situations of Emergency and Crisis: EFA stategic planning
        <a href="https://unesdoc.unesco.org/ark:/48223/pf0000128214" target="_"
          >(UNESCO)
        </a>
      </li>
      <li>Training for Trainer</li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.training {
  margin: 3em 1em;
  /* background: blue; */
}
.training h1 {
  text-align: center;
  text-transform: uppercase;
  font-family: arial, sans-serif;
  color: #010203;
  font-size: 1.4em;
  letter-spacing: 0.1em;
  font-weight: 1000;
  margin-bottom: 0.4em;
  margin: 20px;
}
ul {
  text-align: left;
  list-style-type: none;
  margin-left: 8em;
  /* background: green; */
}
li {
  padding: 0.5em;
  line-height: 150%;
  font-weight: bold;
}
@media screen and (max-width: 880px) {
  /* ul{
   margin-left: 20%; 
} */
}
</style>
